import { ApiError, AuthService } from "@/generated-api";
import { Capacitor } from "@capacitor/core";
import { tryRefreshingTokenNative } from "./tryRefreshingTokenNative";

let sharedRefreshPromise: Promise<string | null> | null = null;

const skipSecondRefresh = (err: unknown): boolean => {
  // don't refresh when logged out
  const isApiError = err instanceof ApiError;
  return isApiError && err.status === 401;
};

export async function tryRefreshingToken(
  setToken: (accessToken: string) => void,
  clearToken: () => void
): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    return tryRefreshingTokenNative(setToken, clearToken);
  }

  if (!sharedRefreshPromise) {
    sharedRefreshPromise = (async () => {
      try {
        const tokenData = await AuthService.refreshTokenApiAuthRefreshPost();
        setToken(tokenData.access_token);
        return tokenData.access_token;
      } catch (err) {
        if (skipSecondRefresh(err)) {
          clearToken();
          return null;
        }
        // Retry once after short delay
        await new Promise((r) => setTimeout(r, 300));
        try {
          const retryData = await AuthService.refreshTokenApiAuthRefreshPost();
          setToken(retryData.access_token);
          return retryData.access_token;
        } catch (finalErr) {
          clearToken();
          throw finalErr;
        }
      }
    })().finally(() => {
      sharedRefreshPromise = null;
    });
  }

  return sharedRefreshPromise;
}
